"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createTimestampStyle;

function createTimestampStyle(_ref) {
  var timestampColor = _ref.timestampColor,
      primaryFont = _ref.primaryFont,
      fontSizeSmall = _ref.fontSizeSmall;
  return {
    color: timestampColor,
    fontFamily: primaryFont,
    fontSize: fontSizeSmall,
    paddingTop: 5
  };
}